/* eslint-disable import/no-anonymous-default-export */
import Axios from "axios";
import constant from "../constant";
import api from "../api";

export default {
  GENERATE_OTP: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Auth.GENERATE_OTP(),
          data
        );

        //
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  UPDATE_PROFILE: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.put(
          constant.BASE_URL + api.Auth.UPDATE_PROFILE(),
          data
        );

        //
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  GET_PROFILE: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(
          constant.BASE_URL + api.Auth.GET_PROFILE()
        );

        //
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
  LOGIN_WITH_OTP: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.Auth.LOGIN_WITH_OTP(),
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response?.data?.tokens?.access?.token) {
          localStorage.setItem('access_token', response.data.tokens.access.token)
        }

        Axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${localStorage.getItem("access_token")}`;
        resolve(response);
      } catch (err) {
     
        reject(err);
      }
    });
  },
  DELETE_ACCOUNT: () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.delete(
          constant.BASE_URL + api.Auth.DELETE_ACCOUNT()
        );

        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
 
};
